import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BookPharmacist = () => {
  const [form, setForm] = useState({
    name: '',
    age: '',
    gender: '',
    healthConditions: '',
    prescriptionText: '',
  });

  const navigate = useNavigate();

  useEffect(() => {
    console.log('Form data:', form);
    const userData =
      JSON.parse(localStorage.getItem('currentUser')) ||
      JSON.parse(localStorage.getItem('loggedInUser'));

    if (userData) {
      const calculateAge = (dob) => {
        if (!dob) return '';
        const birthDate = new Date(dob);
        const diff = Date.now() - birthDate.getTime();
        return new Date(diff).getUTCFullYear() - 1970;
      };

      setForm((prevForm) => ({
        ...prevForm,
        name: userData.name || '',
        gender: userData.gender || '',
        age: userData.age || calculateAge(userData.dob) || '',
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem('currentUser')) || JSON.parse(localStorage.getItem('loggedInUser'));
    if (user && user.email) {
      console.log('Booking Submitted:', form);
      navigate('/booking-success');
    } else {
      navigate('/login');
    }
  };

  return (
    <div className="container mt-5">
      <h2 className="text-center mb-4">Book a Pharmacist Appointment</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">Name</label>
          <input
            type="text"
            className="form-control"
            id="name"
            name="name"
            value={form.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="age" className="form-label">Age</label>
          <input
            type="number"
            className="form-control"
            id="age"
            name="age"
            value={form.age}
            onChange={handleChange}
            required
          />
        </div>
        <div className="mb-3">
          <label htmlFor="gender" className="form-label">Gender</label>
          <select
            className="form-control"
            id="gender"
            name="gender"
            value={form.gender}
            onChange={handleChange}
            required
          >
            <option value="">Select Gender</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div className="mb-3">
          <label htmlFor="healthConditions" className="form-label">Health Conditions</label>
          <textarea
            className="form-control"
            id="healthConditions"
            name="healthConditions"
            value={form.healthConditions}
            onChange={handleChange}
            rows="4"
            required
          ></textarea>
        </div>
        <button type="submit" className="btn btn-success w-100">Book Appointment</button>
      </form>
    </div>
  );
};

export default BookPharmacist;
